// 2026-09-06：维护放行只保存在内存，绑定真实登录、当前机构、服务端运行域和维护批次；刷新或退出后重新验证。
type Context={token:string;customerId:number;orgId:number}
type WindowConfig={enabled:boolean;updatedAt:string}
export function createMaintenanceTester(getContext:()=>Context,fetchAccess:()=>Promise<any>,now:()=>number=Date.now){
  let serial=0
  let grant:{context:Context;revision:string;runtimeId:string;expiresAt:number}|null=null
  // 2026-09-08：缓存登录和同一客户的凭证轮换必须重新向服务端核验；合并并发请求并丢弃旧会话回包。
  let pending:{context:Context;revision:string;promise:Promise<boolean>}|null=null
  const same=(a:Context,b:Context)=>a.token===b.token && a.customerId===b.customerId && a.orgId===b.orgId
  const sameIdentity=(a:Context,b:Context)=>a.customerId===b.customerId && a.orgId===b.orgId
  const clear=()=>{serial++;grant=null;pending=null}
  const active=(config:WindowConfig)=>Boolean(config.enabled && grant && grant.revision===config.updatedAt
    && grant.expiresAt>now() && same(grant.context,getContext()))
  // 只允许复核期间隐藏并保留同一客户已挂载的页面，不能据此显示页面或授予访问资格。
  const canRevalidate=(config:WindowConfig)=>Boolean(config.enabled && grant && grant.revision===config.updatedAt
    && getContext().token && sameIdentity(grant.context,getContext()))
  return {
    begin(){clear()},clear,active,canRevalidate,
    async verify(config:WindowConfig){
      if(!config.enabled){clear();return false}
      const context={...getContext()},revision=config.updatedAt
      if(!context.token || !Number.isSafeInteger(context.customerId) || context.customerId<=0
        || !Number.isSafeInteger(context.orgId) || context.orgId<=0 || !revision){clear();return false}
      if(pending && pending.revision===revision && same(pending.context,context))return pending.promise
      if(grant && (grant.revision!==revision || !sameIdentity(grant.context,context)))grant=null
      const previous=grant,requestSerial=++serial
      const promise=(async()=>{
        try{
          const response=await Promise.resolve().then(fetchAccess)
          if(requestSerial!==serial || !same(context,getContext())) return false
          if(response?.allowed!==true || response.customerId!==context.customerId || response.orgId!==context.orgId
            || response.maintenanceRevision!==revision || typeof response.runtimeId!=='string' || !response.runtimeId
            || previous && previous.runtimeId!==response.runtimeId || !Number.isFinite(response.expiresAt) || response.expiresAt<=now()){
            grant=null;return false
          }
          grant={context,revision,runtimeId:response.runtimeId,expiresAt:Math.min(response.expiresAt,now()+30000)}
          return true
        }catch(_error){if(requestSerial===serial)grant=null;return false}
        finally{if(requestSerial===serial)pending=null}
      })()
      pending={context,revision,promise}
      return promise
    }
  }
}
